import { SelectSingle } from "@components/Select";
import { Dispatch, FC, memo, SetStateAction, useCallback, useMemo, useState } from "react";
import { useKeywords } from "@core/CommonDataContext";
import { Metric } from "@models/Metric";
import { IOption } from "@models";
import { Tooltip } from "@datassential/platform-ui-lib";

const CorrelationMainFilters: FC<{
    selectedMetric: Metric,
    setSelectedMetric: Dispatch<SetStateAction<Metric>>,
    mainKeywordId: number | null,
    setMainKeywordId: Dispatch<SetStateAction<number | null>>,
    metricOptions: IOption<Metric, string>[],
    selectedMetricName: string,
    keywordName: string,
    isLoading: boolean,
    ofTotalUs: number | null,
}> = ({
    selectedMetric,
    setSelectedMetric,
    mainKeywordId,
    setMainKeywordId,
    metricOptions,
    selectedMetricName,
    keywordName,
    isLoading,
    ofTotalUs,
}) => {
    const [isSearching, setIsSearching] = useState(false)
    const keywords = useKeywords()

    const keywordItems = useMemo(
        () => {
            return keywords.map(keyword => ({
                id: keyword.id ?? 0,
                title: keyword.name ?? '',
            }));
        },
        [keywords]
    );

    const onSearchOpenClose = useCallback(
        (isOpened: boolean) => setIsSearching(isOpened),
        []
    );

    const showTooltip = useMemo(
        () => !isSearching && mainKeywordId === null,
        [isSearching, mainKeywordId]
    );

    return (
        <div className="CorrelationMainFilters">
            <SelectSingle
                className="CorrelationMainFilters__select-metric"
                label={<span className="CorrelationMainFilters__metric-label">THOSE WHO:</span>}
                value={selectedMetric}
                setValue={setSelectedMetric}
                options={metricOptions}
                testId="selectCorrelationMetric"
            />
            <div data-tooltip-id="correlation-select-keyword">
                <SelectSingle
                    className="CorrelationMainFilters__search-select"
                    testId="selectCorrelationKeyword"
                    value={mainKeywordId}
                    setValue={setMainKeywordId}
                    options={keywordItems}
                    placeholder="-"
                    dropdownProps={{
                        isInPortal: false,
                        place: "bottom-end",
                    }}
                    style={{
                        position: 'relative',
                        zIndex: 2,
                    }}
                    hideSelected
                    onOpenChange={onSearchOpenClose}
                    hasSearch
                    isVirtualized
                />
            </div>
            <Tooltip
                id="correlation-select-keyword"
                className="CorrelationMainFilters__tooltip levitate"
                isOpen={showTooltip}
            >
                <span data-testid="textCorrelationKeywordTooltip">Start by searching for a food or flavor</span>
            </Tooltip>
            {
                keywordName && !isLoading ? (
                    <span
                        className="CorrelationMainFilters__headline appears-left"
                        data-testid="textCorrelationHeadline"
                    >
                        {ofTotalUs}% of the total US&nbsp;
                        <span className="CorrelationMainFilters__selected-text">
							{selectedMetricName} <strong className="Correlation__bold-text">{keywordName}</strong>
						</span>
                    </span>
                ) : null
            }
        </div>
    )
}

export default memo(CorrelationMainFilters);